import React from 'react';
import styles from './index.module.css';

const Footer = () => {
  return (
    <p className={styles.footer}>
      Desenvolvido por <a href="https://github.com/JPerluxo" target="_blank" rel="noreferrer">Jefferson Perluxo Clemente</a>
    </p>
  )
}

export default Footer;